import { Component } from "@grafikr/components";
import Drawer from "utils/components/drawer";
import { disableBodyScroll, enableBodyScroll } from "utils/body-scroll";

export default Component((node, { onMounted }) => {
  const drawer = new Drawer(node);

  const closeButton = node.querySelector("[data-close]");

  closeButton.addEventListener("click", drawer.close);

  const openPassportButton = document.querySelector("[data-open-passport]");
  if (openPassportButton) {
    openPassportButton.addEventListener("click", drawer.open);
  }

  drawer.on("open", () => disableBodyScroll(document.body));
  drawer.on("close", () => enableBodyScroll(document.body));

  const outerScroll = node.querySelector('[data-outer-scroll]');
  const innerScroll = node.querySelector('[data-inner-scroll]');
  const scrollSpacer = node.querySelector<HTMLElement>('[data-scroll-spacer]');

  onMounted(() => {
    if (window.location.hash.includes("dpp")) {
      sessionStorage.setItem("dpp-hash", window.location.hash);

      drawer.open();

      setTimeout(() => {
        if (window.location.hash !== sessionStorage.getItem("dpp-hash")) {
          window.location.hash = sessionStorage.getItem("dpp-hash");
        }
      }, 1000);
    }
  });

  if (outerScroll && innerScroll) {
    let scrollTimeout: number;
    
    const handleScroll = () => {
      if (scrollSpacer) {
        const scrollTop = outerScroll.scrollTop;
        const clientHeight = outerScroll.clientHeight;
        const scrollHeight = outerScroll.scrollHeight;
        const maxScroll = scrollHeight - clientHeight;
        const scrollProgress = Math.min(scrollTop / maxScroll, 1);
        
        const logarithmicProgress = Math.pow(scrollProgress, 0.6);
        const opacity = Math.min(logarithmicProgress * 0.7, 0.7);
        
        scrollSpacer.style.opacity = opacity.toString();
      }
      
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      scrollTimeout = window.setTimeout(() => {
        const scrollTop = outerScroll.scrollTop;
        const clientHeight = outerScroll.clientHeight;
        const scrollHeight = outerScroll.scrollHeight;
        
        const tolerance = 5;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - tolerance;
        
        if (isAtBottom) {
          innerScroll.classList.remove('overflow-y-hidden');
          innerScroll.classList.add('overflow-y-auto');
        } else {
          innerScroll.classList.add('overflow-y-hidden');
          innerScroll.classList.remove('overflow-y-auto');
        }
      }, 50);
    };

    outerScroll.addEventListener('scroll', handleScroll, { passive: true });
  }

});
